export default {
  engagementInformationTemplateTopic(state) {
    return state.engagementInformationTemplateTopic;
  },
};
